import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asDetailTab, type DetailTabId } from '@/features/ai/ai-href';
import { ModelDetailPage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Détail d’un alias de modèle. */
export const Route = createFileRoute('/$tenant/llm/models/$modelId')({
  validateSearch: (search: Record<string, unknown>): { tab: DetailTabId } => ({
    tab: asDetailTab(search['tab']),
  }),
  component: ModelDetailRoute,
});

function ModelDetailRoute() {
  const { tenant, modelId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="llmGateway"
      crumbs={[
        { label: t('nav.items.llmGateway') },
        { label: <EntityName tenantId={tenant} kind="llmModel" id={modelId} /> },
      ]}
    >
      <ModelDetailPage
        tenantId={tenant}
        modelId={modelId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
